module.exports = __webpack_public_path__ + "static/default-broker-image-ee15ae122aa1497258a6eef533e9bb1a.png";